import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchDepartment from "utils/fetch/FetchDepartment";

export default class FetchCachedDepartment
{
	static logName = 'FetchCachedDepartment';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'departments',
				tables: [ 'departments' ],
				onExpire: FetchCachedDepartment.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess({
							departments: this.values
						})
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
		})
			);
		});
	}
	
	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchDepartment.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( { departments = null } ) => {
						// Save to object
						this.process( departments );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, departments, true );

						if( callbackSuccess !== null ) {
							callbackSuccess({
								departments: departments
							});
						}
					}
				})
			);
		}
		);
	}
	
	static process = ( departments ) => {
		this.values = departments;
		store.dispatch( addDataByGuid( dataConstants.DEPARTMENTS, this.values ) );
	}
}
